export const PRODUCT_CATEGORY_CONFIG = {
    CATEGORY_LIST: {
      endPoint: 'category', // includes the query param
      version: 'v1',
      method: 'GET',
      baseUrlKey: 'inventoryApiUrl', // Dynamically use PRODUCTS_API_URL
    },
  }
  